export default __webpack_public_path__ + "static/media/img_24.9e6d03ac.jpg";